import React from "react";
import {PasswordInput} from "../../core";

export const PasswordField = ({onChange,onEnter=()=>{},label="Password",autoFocus=false,score,value}) => {
    return <PasswordInput placeholder={"**********"} onEnter={onEnter} score={score} onChange={onChange} value={value} label={label} autoFocus={autoFocus} />;
};